module.exports = __webpack_public_path__ + "static/media/logo.836454dd.svg";